import Component from '../../../components/Component';
import Timeline from '../../../components/Timeline';
import Loading from '../../../components/Loading';

import query from './query';
import keys from './keys';
import { getLabel } from '../../../helpers/date';
import { colors } from '../../../lib/colors';
import { withTranslation } from 'react-i18next';

class GSCReportDirectoryDetailChart extends Component {
    constructor(props) {
        super();
        this.query = query(props.directory, props.subdomain);
    }

    render() {
        const { t } = this.props;

        if (this.state.loading) {
            return <Loading />;
        }

        const chartData = (datasetIndex) => ({
            labels: this.state.data.map((item) => [
                getLabel(item?.start_date?.value),
                getLabel(item?.end_date?.value),
            ]),
            datasets: keys(t).map((item, i) => ({
                label: item?.label,
                type: 'line',
                data: this.state.data.map((data) =>
                    item.render ? item.render(data[item.key]) : data[item.key],
                ),

                backgroundColor: [colors[i], colors[i]],
                borderColor:
                    datasetIndex === null || datasetIndex === i
                        ? colors[i]
                        : 'rgba(128, 128, 128, 0.2)',
                yAxisID: item.yAxisID ?? 'y',
                borderRadius: 4,
                tension: 0.4,
            })),
        });

        return (
            <Timeline
                chartSize="lg"
                metricType="primary"
                data={this.state.data}
                error={this.state.error}
                keys={keys(t)}
                parent_id={this.props.parent_id}
                content_id={this.props.content_id}
                forceRun={this.forceRun}
                hasRightAxis
                chartData={chartData}
                xAxisTitle={t('gloabl.week')}
                xAxisKey="start_date"
                rightAxisLabel={t('gloabl.ctr_per')}
                hasSecondRightAxis
                rightSecondAxisLabel={t('gloabl.positions')}
                gsc_report
                showGoogleFeeds
                hasLeftSecondAxis
                leftSecondAxisLabel={t('gloabl.clicks')}
                leftAxisLabel={t('gloabl.impressions')}
                secondRightAxisReversed
            />
        );
    }
}

export default withTranslation()(GSCReportDirectoryDetailChart);
